import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 700,
    lineHeight: 1,
    color: theme.palette.primary.light,
  },
}));
